"use strict";

exports.__esModule = true;
exports.getPluginConfig = exports.MAX_PINTEREST_IMAGE_SIZE = void 0;

var _lodash = require("lodash");

var MAX_PINTEREST_IMAGE_SIZE = 5000;
exports.MAX_PINTEREST_IMAGE_SIZE = MAX_PINTEREST_IMAGE_SIZE;

var getPluginConfig = function getPluginConfig(richContent, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$enableLinks = _ref.enableLinks,
      enableLinks = _ref$enableLinks === void 0 ? true : _ref$enableLinks,
      isCodeBlockPluginEnabled = _ref.isCodeBlockPluginEnabled,
      isFileUploadPluginEnabled = _ref.isFileUploadPluginEnabled;

  var PLUGINS = {
    IMAGE: richContent.IMAGE_TYPE,
    GALLERY: richContent.GALLERY_TYPE,
    VIDEO: richContent.VIDEO_TYPE,
    HASHTAG: richContent.HASHTAG_TYPE,
    DIVIDER: richContent.DIVIDER_TYPE,
    HTML: richContent.HTML_TYPE,
    TEXT_COLOR: richContent.TEXT_COLOR_TYPE,
    LINE_SPACING: richContent.LINE_SPACING_TYPE,
    GIPHY: richContent.GIPHY_TYPE
  };

  if (enableLinks) {
    PLUGINS.LINK = richContent.LINK_TYPE;
  }

  if (isCodeBlockPluginEnabled && richContent.CODE_BLOCK_TYPE) {
    PLUGINS.CODE_BLOCK = richContent.CODE_BLOCK_TYPE;
  }

  if (isFileUploadPluginEnabled && richContent.FILE_UPLOAD_TYPE) {
    PLUGINS.FILE_UPLOAD = richContent.FILE_UPLOAD_TYPE;
  }

  var DEFAULT_PLUGINS = (0, _lodash.values)(PLUGINS);
  return {
    DEFAULT_PLUGINS: DEFAULT_PLUGINS,
    PLUGINS: PLUGINS
  };
};

exports.getPluginConfig = getPluginConfig;